import v3ApiClient from "./client";

const BUSINESS_DASHBOARD_BASE_PATH = "/v3/business-dashboard";

const cleanParams = (params = {}) => {
    const cleaned = {};

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") {
            return;
        }
        if (Array.isArray(value)) {
            if (value.length > 0) {
                cleaned[key] = value.join(",");
            }
            return;
        }
        cleaned[key] = value;
    });

    return cleaned;
};

const getData = async (promise) => {
    const response = await promise;
    return response.data;
};

export const businessDashboardApi = {
    getHealth: () => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/_health`)),

    getOverview: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/overview`, { params: cleanParams(params) })),

    getDataQuality: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/data-quality`, { params: cleanParams(params) })),

    getBhSummary: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/bh/summary`, { params: cleanParams(params) })),

    getBhTimeSeries: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/bh/time-series`, { params: cleanParams(params) })),

    getBhByAircraft: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/bh/by-aircraft`, { params: cleanParams(params) })),

    getBhByRoute: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/bh/by-route`, { params: cleanParams(params) })),

    getAircraft: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/aircraft`, { params: cleanParams(params) })),

    getAircraftCurrentStatus: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/aircraft/current-status`, { params: cleanParams(params) })),

    getRoutesPerformance: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/routes/performance`, { params: cleanParams(params) })),

    getRoutesOtp: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/routes/otp`, { params: cleanParams(params) })),

    getRoutesLoop: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/routes/loop`, { params: cleanParams(params) })),

    getEventsTimeline: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/events/timeline`, { params: cleanParams(params) })),

    getPartnersPerformance: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/partners/performance`, { params: cleanParams(params) })),

    getCargoSummary: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/cargo/summary`, { params: cleanParams(params) })),

    getCargoByRoute: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/cargo/by-route`, { params: cleanParams(params) })),

    getCargoByFlight: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/cargo/by-flight`, { params: cleanParams(params) })),

    getAircraftAvailability: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/aircraft/availability`, { params: cleanParams(params) })),

    getOperatorGroups: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/aircraft/operator-groups`, { params: cleanParams(params) })),

    getAogEvents: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/aog/events`, { params: cleanParams(params) })),

    getCapacityOutlook: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/capacity/outlook`, { params: cleanParams(params) })),

    getMetricSnapshots: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/metrics/snapshots`, { params: cleanParams(params) })),

    getRisks: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/risks`, { params: cleanParams(params) })),

    getCommercialFlights: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/commercial-flights`, { params: cleanParams(params) })),

    getCommercialFlightDetail: (commercialFlightKey, params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/commercial-flights/${encodeURIComponent(commercialFlightKey)}`, { params: cleanParams(params) })),

    getLegs: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/legs`, { params: cleanParams(params) })),

    getCustomersPerformance: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/customers/performance`, { params: cleanParams(params) })),

    getCustomerFulfillment: (customerId, params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/customers/${encodeURIComponent(customerId)}/fulfillment`, { params: cleanParams(params) })),

    getSalesSummary: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/sales/summary`, { params: cleanParams(params) })),

    getSalesContracts: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/sales/contracts`, { params: cleanParams(params) })),

    getSalesContractPerformance: (contractId, params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/sales/contracts/${encodeURIComponent(contractId)}/performance`, { params: cleanParams(params) })),

    getRevenueByFlight: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/sales/revenue-by-flight`, { params: cleanParams(params) })),

    getFuelSurchargeDifferences: (params = {}) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/sales/fuel-surcharge-differences`, { params: cleanParams(params) })),

    createRefreshJob: (payload) => getData(v3ApiClient.post(`${BUSINESS_DASHBOARD_BASE_PATH}/refresh-jobs`, payload)),

    getRefreshJob: (jobId) => getData(v3ApiClient.get(`${BUSINESS_DASHBOARD_BASE_PATH}/refresh-jobs/${encodeURIComponent(jobId)}`)),
};

export default businessDashboardApi;
